<ng-container *ngIf="(accessPeriod$ | async) as accessPeriod">
  <prlw-status-for-icon-ui
    [accessPeriod]="accessPeriod"
  ></prlw-status-for-icon-ui>
</ng-container>
